export default __webpack_public_path__ + "static/social-media-phone-1717fda5b6e32e655958a76ab24c6755.gif";